import { Enum } from "@/commons/enums/Type";

export class OsEnum {
  static ANDROID = { value: 1, text: "Android" };
  static BSD = { value: 2, text: "BSD" };
  static CHROME_OS = { value: 3, text: "ChromeOS" };
  static IPAD = { value: 4, text: "iPad" };
  static IPHONE = { value: 5, text: "iPhone" };
  static IPOD = { value: 6, text: "iPod" };
  static LINUX = { value: 7, text: "Linux" };
  static MAC_OSX = { value: 8, text: "Mac OSX" };
  static UNKNOWN = { value: 9, text: "UNKNOWN" };
  static WINDOWS_10 = { value: 10, text: "Windows 10" };
  static WINDOWS_11 = { value: 11, text: "Windows 11" };
  static WINDOWS_2000 = { value: 12, text: "Windows 2000" };
  static WINDOWS_7 = { value: 13, text: "Windows 7" };
  static WINDOWS_8 = { value: 14, text: "Windows 8" };
  static WINDOWS_8_POINT_1 = { value: 15, text: "Windows 8.1" };
  static WINDOWS_PHONE_OS = { value: 16, text: "Windows Phone OS" };
  static WINDOWS_UNKNOWN_VER = { value: 17, text: "Windows UNKNOWN Ver" };
  static WINDOWS_VISTA = { value: 18, text: "Windows Vista" };
  static WINDOWS_XP = { value: 19, text: "Windows XP" };
  static XBOX_ONE = { value: 20, text: "Xbox One" };

  static getByValue(value: number): Enum | undefined {
    if (value === OsEnum.ANDROID.value) {
      return OsEnum.ANDROID;
    }
    if (value === OsEnum.BSD.value) {
      return OsEnum.BSD;
    }
    if (value === OsEnum.CHROME_OS.value) {
      return OsEnum.CHROME_OS;
    }
    if (value === OsEnum.IPAD.value) {
      return OsEnum.IPAD;
    }
    if (value === OsEnum.IPHONE.value) {
      return OsEnum.IPHONE;
    }
    if (value === OsEnum.IPOD.value) {
      return OsEnum.IPOD;
    }
    if (value === OsEnum.LINUX.value) {
      return OsEnum.LINUX;
    }
    if (value === OsEnum.MAC_OSX.value) {
      return OsEnum.MAC_OSX;
    }
    if (value === OsEnum.UNKNOWN.value) {
      return OsEnum.UNKNOWN;
    }
    if (value === OsEnum.WINDOWS_10.value) {
      return OsEnum.WINDOWS_10;
    }
    if (value === OsEnum.WINDOWS_11.value) {
      return OsEnum.WINDOWS_11;
    }
    if (value === OsEnum.WINDOWS_2000.value) {
      return OsEnum.WINDOWS_2000;
    }
    if (value === OsEnum.WINDOWS_7.value) {
      return OsEnum.WINDOWS_7;
    }
    if (value === OsEnum.WINDOWS_8.value) {
      return OsEnum.WINDOWS_8;
    }
    if (value === OsEnum.WINDOWS_8_POINT_1.value) {
      return OsEnum.WINDOWS_8_POINT_1;
    }
    if (value === OsEnum.WINDOWS_PHONE_OS.value) {
      return OsEnum.WINDOWS_PHONE_OS;
    }
    if (value === OsEnum.WINDOWS_UNKNOWN_VER.value) {
      return OsEnum.WINDOWS_UNKNOWN_VER;
    }
    if (value === OsEnum.WINDOWS_VISTA.value) {
      return OsEnum.WINDOWS_VISTA;
    }
    if (value === OsEnum.WINDOWS_XP.value) {
      return OsEnum.WINDOWS_XP;
    }
    if (value === OsEnum.XBOX_ONE.value) {
      return OsEnum.XBOX_ONE;
    }
    return undefined;
  }

  static getList(): Enum[] {
    return [
      OsEnum.ANDROID,
      OsEnum.BSD,
      OsEnum.CHROME_OS,
      OsEnum.IPAD,
      OsEnum.IPHONE,
      OsEnum.IPOD,
      OsEnum.LINUX,
      OsEnum.MAC_OSX,
      OsEnum.UNKNOWN,
      OsEnum.WINDOWS_10,
      OsEnum.WINDOWS_11,
      OsEnum.WINDOWS_2000,
      OsEnum.WINDOWS_7,
      OsEnum.WINDOWS_8,
      OsEnum.WINDOWS_8_POINT_1,
      OsEnum.WINDOWS_PHONE_OS,
      OsEnum.WINDOWS_UNKNOWN_VER,
      OsEnum.WINDOWS_VISTA,
      OsEnum.WINDOWS_XP,
      OsEnum.XBOX_ONE,
    ];
  }
}
